<template>
  <ReservationEdit
    v-if="selectedReservation !== null"
    @close="goToReservationDetailPage"
    @reservationEdited="goToReservationDetailPage"
  />
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { onMounted, toRefs } from 'vue'
import { useRouter } from 'vue-router'

import { PERFORMANCE_ROUTE_NAMES } from '@/modules/performance/constants/PerformanceRouteConstants'
import { usePerformanceReservationStore } from '@/modules/performance/stores/PerformanceReservationStore'
import ReservationEdit from '@/modules/reservation/pages/ReservationEdit.vue'

import { PerformanceId, ReservationId } from '@generated/types'

const props = defineProps<{ reservationId: ReservationId; performanceId: PerformanceId }>()
const { reservationId, performanceId } = toRefs(props)

const router = useRouter()
const performanceReservationStore = usePerformanceReservationStore()
const { selectedReservation } = storeToRefs(performanceReservationStore)
onMounted(async () => {
  await performanceReservationStore.loadSelectedReservation(reservationId.value)
  if (selectedReservation.value?.performance_id !== performanceId.value) {
    await router.push({ name: PERFORMANCE_ROUTE_NAMES.RESERVATION_LIST })
  }
})
async function goToReservationDetailPage() {
  performanceReservationStore.setSelectedTableIds([])
  await router.replace({ name: PERFORMANCE_ROUTE_NAMES.RESERVATION_DETAIL })
}
</script>
